import * as React from "react"
import { SVGProps } from "react"

const SvgPaintingBoardBold = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="-0.6 -0.6 14 14" {...props}>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2}>
      <path d="M1.371 8.686V1.37a.914.914 0 0 1 .915-.914h8.228a.914.914 0 0 1 .915.914v7.315" />
      <path d="m3.895 8.686 4.992-3.548a.6.6 0 0 1 .686 0L11.429 6.4M4.8 5.029a1.143 1.143 0 1 0 0-2.286 1.143 1.143 0 0 0 0 2.286M.457 8.686h11.886M6.4 8.686v3.657M5.029 8.686l-2.743 3.657M7.771 8.686l2.743 3.657" />
    </g>
  </svg>
)
export default SvgPaintingBoardBold
